<script lang="ts">
	import { ReadmeViewerProps } from '../models/props';

	let { content, filename = 'README.md' }: ReadmeViewerProps = $props();
</script>

<section class="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
	<div class="p-3 bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
		<h3 class="font-semibold text-gray-900 dark:text-gray-200 flex items-center">
			<svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
				<path
					fill-rule="evenodd"
					d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z"
					clip-rule="evenodd"
				/>
			</svg>
			{filename}
		</h3>
	</div>
	<div class="p-6 bg-white dark:bg-gray-900">
		<div class="prose dark:prose-invert max-w-none">
			<div class="text-gray-900 dark:text-gray-300 whitespace-pre-wrap">
				{@html content}
			</div>
		</div>
	</div>
</section>
